import { Box, Typography, Paper } from '@mui/material';
import { useTranslation } from 'react-i18next';

export const MainErrorFallback = ({ error }: { error: Error }) => {
  const { t } = useTranslation();
  console.error(error);

  return (
    <Box
      sx={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        minHeight: '100vh',
        p: 2,
      }}
    >
      <Paper
        elevation={3}
        sx={{
          p: 4,
          maxWidth: 600,
          width: '100%',
          textAlign: 'center',
          bgcolor: 'error.light',
          color: 'error.contrastText',
        }}
      >
        <Typography variant="h5" component="h1" gutterBottom>
          {t('common.errors.somethingWentWrong')}
        </Typography>
        <Typography variant="body1" sx={{ wordBreak: 'break-word' }}>
          {error.message}
        </Typography>
      </Paper>
    </Box>
  );
};

export default MainErrorFallback;
